export default class Question {
    constructor(title, reserved, level, answers) {
      this.title = title;
      this.reserved = reserved;
      this.level = level;
      this.answers = answers;
    }
}